import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";

import { notBlank } from "../../util/ext";
import Grid from "@material-ui/core/Grid";
import { useHistory, useLocation, useParams } from "react-router-dom";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import { Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Header from "../../creator-application/common/Header";
import { useContentMetadataParseEvent } from "./processingDiscoveryServices";
import ContentMetadataParseEventCard from "./ContentMetadataParseEventCard";
import ContentMetadataErrorsCard from "./ContentMetadataErrorsCard";

const useStyles = makeStyles(theme => ({
  root: {
    border: "3px white solid",
    backgroundColor: "white",
    borderRadius: "20px",
  },

  panel: {
    backgroundColor: "white",
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    maxHeight: "calc(100vh - 300px)",
    minHeight: "calc(100vh - 300px)",
    overflowY: "auto",
  },
}));

const ParsedMetadataDetailView = () => {
  const classes = useStyles();
  const history = useHistory();
  const { state = {} } = useLocation();
  const { jobId, mediaId } = useParams();

  const [metadataParse, setMetadataParse] = useState(null);
  const eventResponse = useContentMetadataParseEvent(jobId, mediaId);
  useEffect(() => {
    if (eventResponse.isSuccess && notBlank(eventResponse.data)) {
      setMetadataParse(eventResponse.data);
    }
  }, [eventResponse.isSuccess, eventResponse.data]);

  return (
    <Container
      id="content-metadata-parse-view"
      classes={{ root: classes.root }}
    >
      {eventResponse.isLoading && (
        <Container style={{ height: 400 }}>
          <PanelLoadingIndicator />
        </Container>
      )}
      {eventResponse.isSuccess && notBlank(metadataParse) && (
        <Fragment>
          <Header
            title="Content Metadata Parse Event Details"
            selectedActions={
              <Box>
                <Button
                  variant="text"
                  startIcon={<ArrowBackIcon />}
                  onClick={() =>
                    notBlank(state) && notBlank(state.previousLocation)
                      ? history.push(state.previousLocation)
                      : history.push(`/metadata-discovery-report/${jobId}`)
                  }
                >
                  {notBlank(state) && notBlank(state.label)
                    ? state.label
                    : "Back to Discovery Details"}
                </Button>
              </Box>
            }
          />
          <Container classes={{ root: classes.panel }}>
            <Grid container spacing={2}>
              <Grid item sm={12}>
                <ContentMetadataParseEventCard
                  contentMetadataParseEvent={metadataParse}
                />
              </Grid>

              <Grid item sm={12}>
                <ContentMetadataErrorsCard jobId={jobId} mediaId={mediaId} />
              </Grid>
            </Grid>
          </Container>
        </Fragment>
      )}
    </Container>
  );
};

export default ParsedMetadataDetailView;
